import * as React from "react";
import { getBrandThemeFromDomain } from "src/utils/brandTheme";

import { LogoSpinner } from "./logo-spinner";

export interface ContentSuspenseProps {
  children: React.ReactNode;
  height?: string;
  spinnerColor?: string;
  fallback?: React.ReactNode; // Custom fallback component
}

/**
 * A Suspense wrapper specifically for content areas that need loading states
 * but should preserve the overall page layout
 */
export const ContentSuspense: React.FC<ContentSuspenseProps> = ({
  children,
  height = "h-[400px]",
  spinnerColor = "text-slate-400",
  fallback,
}) => {
  const DefaultLoadingContent = () => (
    <div className={`flex justify-center items-center ${height}`}>
      <LogoSpinner className={spinnerColor} brandTheme={getBrandThemeFromDomain()} />
    </div>
  );

  // Use custom fallback if provided, otherwise use default
  const fallbackContent = fallback ?? <DefaultLoadingContent />;

  return (
    <React.Suspense fallback={fallbackContent}>
      {children}
    </React.Suspense>
  );
};